import { render, staticRenderFns } from "./DatasourceDsTabUser.vue?vue&type=template&id=5e0de9f0&scoped=true&lang=pug"
import script from "./DatasourceDsTabUser.vue?vue&type=script&lang=js"
export * from "./DatasourceDsTabUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0de9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0de9f0')) {
      api.createRecord('5e0de9f0', component.options)
    } else {
      api.reload('5e0de9f0', component.options)
    }
    module.hot.accept("./DatasourceDsTabUser.vue?vue&type=template&id=5e0de9f0&scoped=true&lang=pug", function () {
      api.rerender('5e0de9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/DatasourceDsTabUser.vue"
export default component.exports